import React, {memo, useContext} from "react"

import {Grid, Snackbar} from "@mui/material"

import ErrorContext from "../../context/ErrorContext"
import CommonUtils from "../../utils/Common"
import Routing from "../../utils/Routing"

function Body(props: any) {
    const errorContext = useContext(ErrorContext)
    const isRoleSelected = CommonUtils.ToBoolean(CommonUtils.GetLocal("isRoleSelected"))

    return (
        <>
            <Grid className="appBody">
                {isRoleSelected ? Routing.DisplayPage(props.page) : <Grid>{Routing.DisplayPage(props.page)}</Grid>}
            </Grid>
            <Snackbar open={errorContext.isError} anchorOrigin={{vertical: "top", horizontal: "right"}}>
                <div></div>
            </Snackbar>
        </>
    )
}

export default memo(Body)
